export const getChangedGoodKeys = (data) => {
  const changes = [];
  const after = {};
  const before = {};

  for (const key in data) {
    if (key.startsWith("client_good_")) {
      const suffix = key.replace("client_good_", "");
      if (suffix === "id") continue;

      const oldKey = `good_${suffix}`;

      if (oldKey in data && data[key] !== data[oldKey]) {
        changes.push({
          field: suffix,
          oldValue: data[oldKey],
          newValue: data[key],
        });
        after[suffix] = data[key];
        before[suffix] = data[oldKey];
      }
    }
  }

  return { changes, after, before };
};

export const getChangedGoodsFromAfterBefore = (after, before) => {
  const changes = [];
  for (const key in after) {
    changes.push({
      field: key,
      oldValue: before[key],
      newValue: after[key],
    });
  }

  return changes;
};
